Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Context3DRenderMode = module.exports.default = {
	AUTO: "auto",
	SOFTWARE: "software"
};